import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExportCandidateDocumentsComponent } from './export-candidate-documents.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [ExportCandidateDocumentsComponent],
  imports: [
    CommonModule,
    FormsModule
  ],
  exports: [ExportCandidateDocumentsComponent],
  entryComponents: [ExportCandidateDocumentsComponent]
})
export class ExportCandidateDocumentsModule { }
